import Product from "../Shared/Product";
import { ThemeContext } from "../../Contexts/ThemeContext";
import { useContext } from "react";
// import "../HomePersonalCare/HomePersonalCare";
import { Link } from "react-router-dom";
import leaf1 from "../../Images/leaf1.png";

const HairColorSection = () => {
  const {hairColor } = useContext(ThemeContext);
  // const products = summerMakeup
  const products = hairColor?.slice(0, 6);
  // console.log(products);
  return (
    <div className="rele overflow-hidden bg-white">
      <div className="relative">
        {/* Decorative leaf image for visual aesthetics */}
        <img
          className="w-[120px] lg:w-[300px] z-0 opacity-90 hidden   absolute bottom-0 lg:bottom-[50px] left-[-30px] lg:left-[-80px]"
          alt="Decorative natural leaf element"
          src={leaf1}
          loading="lazy"
        />

        {/* ✅ Semantic landmark for SEO */}

        <div className="bg-white h-[15vh]"></div>
        <section
          aria-labelledby="personal-care-heading"
          className={`flex flex-col relative z-10 px-[10px] items-center sm:px-[20px] lg:px-[0px] lg:w-[90%] -mt-4 mx-auto ${
            window.innerWidth >= 1920 ? "2xl:w-[65%]" : "2xl:w-[80%]"
          }`}
        >
          {/* ✅ SEO-friendly heading with keywords */}
          <h2
            id="personal-care-heading"
            className="px-4 text-center text-xl text-accent font-bold  sm:text-2xl "
          >
            Hair Color – Hair care, Face care & Body Essentials
          </h2>
          <div className=" w-[100px] mx-auto h-1 bg-accent my-6 mb-16"></div>

          {/* ✅ Product Grid */}
          <div className="mb-7 md:mb-0 grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 sm:gap-6 featured-collections">
            {products?.map((product) => (
              <Product
                key={product?._id} // ✅ Added unique key for React performance
                product={product}
              />
            ))}
          </div>

          {/* ✅ View More CTA with keyword-rich link title */}
          <Link
            to="/product-category/personal care"
            className="text-white bg-accent px-10 rounded sm:mt-20 py-2 hover:bg-secondary ease-in-out duration-200 font-bold mb-10"
            title="Explore all Clariss Personal Care Products"
          >
            View More
          </Link>
        </section>
      </div>
    </div>
  );
};

export default HairColorSection;
